import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/volte-font/MyFontsWebfontsKit.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
